import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=8d5c4734&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../less/store.less?vue&type=style&index=0&id=8d5c4734&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5c4734",
  null
  
)

export default component.exports